import { Link, usePage } from '@inertiajs/react';
import { route } from '../../utils/route';

export function EmptyState() {
  const { defaultCategorySlug } = usePage<{ defaultCategorySlug: string }>().props;
  return (
    <div className="mx-auto max-w-md px-5 py-16 text-center">
      <div className="mb-5 text-6xl text-gray-300">
        <i className="fa fa-box-open" />
      </div>
      <h2 className="mb-3 text-2xl font-semibold text-gray-800">No hay packs disponibles</h2>
      <p className="mb-6 text-[15px] leading-relaxed text-gray-500">
        Por el momento no hay packs de productos disponibles.
        <br />
        Volvé a revisar pronto para ver nuestras ofertas.
      </p>
      <Link
        href={route('products.index', { cat: defaultCategorySlug })}
        className="inline-block rounded-md bg-green-600 px-6 py-3 font-medium text-white no-underline transition-colors hover:bg-green-700 hover:text-white"
      >
        Ver Productos
      </Link>
    </div>
  );
}
